import React from 'react'
import './spinner.css'


function Spinner({label, sublabel, value, min=0, max, onChange, className}) {

  const add= ()=>{
    if(value==max){
      return
    }
    onChange(value+1);
  }
  const remove=()=>{
    if(value==min){
      return
    }
    onChange(value-1);
  }

  return (
    <div className={"spinner-field "+className }>
      <div className="spinner-label">
        {label}
        {sublabel?(
          <span className="sublabel">{sublabel}</span>
        ):null}
      </div>
      <div className="spinner-controls">
        <div className="spinner-button" onClick={remove}>
          <img src="/wp-content/themes/tradewater/dist/widget/images/arrow-spinner-left.svg" alt="left"/>
        </div>
        <div className="spinner-value">
          {value}
        </div>
        <div className="spinner-button" onClick={add}>
          <img src="/wp-content/themes/tradewater/dist/widget/images/arrow-spinner-right.svg" alt="right"/>
        </div>
      </div>
    </div>
    )
}

export default Spinner